import React, { Component } from 'react';
import axios from 'axios';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import FormLabel from '@material-ui/core/FormLabel';
import { withStyles } from "@material-ui/core/styles";
import i18n from '../i18n';
import { withTranslation, Trans } from 'react-i18next';

const styles = theme => ({
  labelMargin: {
    "margin-bottom": 0,
  }
});

class FamilySelector extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      logged: this.props.logged,
      family_list: this.props.family_list,
      family_friend_list: this.props.family_friend_list,
      family: this.props.family,
      family_filters: this.props.family_filters,      
      searchTerm: this.props.searchTerm,
      trackUrlState: this.props.trackUrlState,
      facets: this.props.facets,
    };
  }

  

  handleChange(event) {
    const { searchTerm,family_list,family_friend_list, trackUrlState} = this.state;

    let family = event.target.value;

    

    this.setState({ [event.target.name]: family });

    // Actualiza la familia en PHP
    axios.post('/familysession.php', {
      family: family
    })
    .then(function (response) {
      // Borra los filtros de la URL al cambiar de familia
      //for find.php
      let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?q=" + searchTerm + "&engine=" + family;

      if(!trackUrlState) {
        //for search friendly
        if(family!=''){
          newurl = window.location.protocol + "//" + window.location.host +"/search/"+ family_friend_list[family] + "?q=" + searchTerm ;
        }
        else {
          newurl = window.location.protocol + "//" + window.location.host +"/search?q=" + searchTerm;
        }
      }

      window.history.pushState({ path: newurl }, '', newurl);
      location.reload();
      this.props.getBanner("",event.target.value);
    })
    .catch(function (error) {
      //
    });
  }
  
  componentDidUpdate(prevProps) {
    if(prevProps.searchTerm !== this.props.searchTerm) {
      this.setState({searchTerm: this.props.searchTerm});
    }
  }

  renderFamily(classes, family_list, family_filters, family, facets){
    
    let fam_count = '';
    let allFacetsObj = [];
    let fam_count_arr = [];
    if(Object.keys(this.props.facets).length > 0){
      
      let allFacets = this.props?.facets?.lg_1[0].data;
      
      allFacets.map((fsct) => {
        allFacetsObj.push("f"+fsct.value);
        
        fam_count_arr["f"+fsct.value] = fsct.count;
        
      })

    }
    return(
      Object.keys(family_list).map(key => {
        if (Object.hasOwnProperty.call(family_filters, key)) {

          let isOnFacet = '';
          isOnFacet = allFacetsObj.includes(key);
          return(
            <div className="family-group-list" key={key}>
              <div className={family === key ? "family-list-inner active" : "family-list-inner"}>
                <span className="filter-list-icon">
                  <img src={`/img/svgs/${key}.svg`} alt="filter-list-icon" />
                </span>
                <FormControlLabel 
                  className={`${classes.labelMargin} filter-list`} 
                  key={key} 
                  value={key} 
                  control={<Radio />} 
                  // label={family_list[key]/*.toLowerCase()*/.replaceAll("\\", "")} 
                  label={
                    <Typography className={isOnFacet ? "nactive" : "notactive"}>
                      {
                        `${family_list[key].replaceAll("\\", "")}(${fam_count_arr[key] != undefined ? fam_count_arr[key] : "0"})`
                        // +"("+fam_count_arr[family_list[key]/*.toLowerCase()*/.replaceAll("\\", "")]+")"
                      }
                    </Typography>
                  }
                /> 
              </div>
            </div>
          )    
        }
      })
    );
  }

  render() {
    const { lang, logged, family_list, family, family_filters, familyLabel, facets } = this.state;
    const { t } = this.props;
    const { classes } = this.props;

    let selectedFamily = family;
    if (family == null) {
      selectedFamily = "";
    }

    return (
      <div>
        <FormControl component="fieldset" className="family-group-wrapper">
          {/* <FormLabel component="legend"><Trans>FAMILY</Trans></FormLabel> */}
          <RadioGroup className="top-family-group" aria-label="family" name="family" value={selectedFamily} onChange={(e) => this.handleChange(e)}>            
            <>
              <div className="family-group-list">
                <div className="family-list-inner">
                  <span className="filter-list-icon">
                    <img src="/img/svgs/family.svg" alt="filter-list-icon" />
                  </span>
                  <FormControlLabel className={`${classes.labelMargin} filter-list`} key={"all_families"} value={""} control={<Radio />} label={t(`all families`)} />            
                </div>
              </div>            
            </>
            {this.renderFamily(classes, family_list, family_filters, family, facets)}
          </RadioGroup>
        </FormControl>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(FamilySelector));